import { useDispatch, useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import { X } from "react-feather";

import { updateTranscriptModalState } from "../../Actions";
import { timeInSeconds } from "../../../../utilities";
import { useState } from "react";

const TranscriptBox = ({
  setShouldTranscriptRender,
  shouldTranscriptRender,
}) => {
  const transcripts = useSelector((state) => state?.transcript.transcripts);
  const videoId = useSelector(
    (state) => state?.modalsState.videoTranscript.videoId
  );
  const dispatch = useDispatch();
  const transcript = transcripts.filter((k) => k.video_id === videoId);
  const pinSentence = useSelector(
    (state) => state?.modalsState?.videoTranscript?.pinSentence
  );
  const pinTime = useSelector(
    (state) => state?.modalsState?.videoTranscript?.pinTime
  );

  const [searchVal, setSearchVal] = useState("");
  const searchValLowercase = searchVal.toLowerCase();

  const handlePlayVideoSentence = (timeStamp) => () => {
    dispatch(
      updateTranscriptModalState({ videoStartAt: timeInSeconds(timeStamp) })
    );
  };

  const handleInput = (e) => {
    setSearchVal(e.target.value);
  };

  const handleClear = () => {
    setSearchVal("");
  };

  const filteredContent = transcript?.[0]?.transcription?.filter((k) => {
    const contentLowercase = k.content.toLowerCase();
    return contentLowercase.includes(searchValLowercase);
  });

  if (shouldTranscriptRender)
    return (
      <div className="transcript-box">
        <div className="tb-header">
          <input
            type="text"
            value={searchVal}
            className="search-trans"
            onChange={handleInput}
            placeholder="Search keywords inside the video"
          />
          {searchVal && (
            <X
              className="cross-icon"
              size={24}
              role="button"
              strokeWidth="1"
              onClick={handleClear}
            />
          )}
          <div>
            <img
              role="button"
              onClick={() => setShouldTranscriptRender(!shouldTranscriptRender)}
              src={
                require("@src/assets/images/vyrill/collapse-open-icon.png")
                  .default
              }
              alt=""
            />
          </div>
        </div>
        <div className="tb-title">Sentiment Highlights</div>

        <PerfectScrollbar
          options={{ wheelPropagation: false, minScrollbarLength: 40 }}
          style={{
            maxHeight: "300px",
          }}
        >
          {/* Pinned Sentence */}
          <div className="transcript-row" style={{ paddingBottom: "20px" }}>
            <div>
              <img
                role="button"
                onClick={handlePlayVideoSentence(pinTime)}
                src={
                  require("@src/assets/images/vyrill/play-video-icon.png")
                    .default
                }
                alt=""
              />
            </div>
            <div className="d-flex">
              <div
                className="transcript-description"
                style={{ width: "210px" }}
              >
                <span className="time-duration">{pinTime}</span>
                <span
                  className="transcript-subtitle"
                  style={{
                    color: "#FFFDC7",
                    maxHeight: "30px",
                  }}
                >
                  {" "}
                  {/* pinSentence */}
                  {pinSentence}
                </span>
              </div>
              <img
                src={require("@src/assets/images/icons/white-pinn.png").default}
                style={{
                  objectFit: "scale-down",
                }}
                width={30}
                alt=""
              />
            </div>
          </div>
          {filteredContent?.length > 0 ? (
            filteredContent.map((k, index) => (
              <div className="transcript-row" key={index}>
                <div>
                  <img
                    role="button"
                    onClick={handlePlayVideoSentence(k?.start_time)}
                    src={
                      require("@src/assets/images/vyrill/play-video-icon.png")
                        .default
                    }
                    alt=""
                  />
                </div>
                <div className="d-flex">
                  <div className="transcript-description">
                    <span className="time-duration">{k?.start_time}:</span>
                    <span className="transcript-subtitle"> {k?.content}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div></div>
          )}
        </PerfectScrollbar>

        {/* </div> */}
      </div>
    );
  else {
    return (
      <div className="transcript-box-hide d-flex">
        <div
          className="collapse-close"
          onClick={() => setShouldTranscriptRender(!shouldTranscriptRender)}
        >
          <img
            src={
              require("@src/assets/images/vyrill/collapse-close-icon.png")
                .default
            }
            alt=""
            style={{ zIndex: "1000" }}
          />
        </div>
      </div>
    );
  }
};
export default TranscriptBox;
